import { DoorClosedIcon } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { BanReason } from "@/generated-api";
import { useTranslation } from "@/hooks/useTranslation";

export default function BannedStatus({
  banReason,
}: {
  banReason: BanReason | null;
}) {
  const t = useTranslation();

  return (
    <Card className="dark max-w-xl">
      <CardContent className="flex flex-col items-center w-full py-10">
        <DoorClosedIcon className="h-24 w-full mb-8" strokeWidth={1} />
        <h4 className="text-l font-semibold leading-none tracking-tight text-gray-200 mb-4">
          {t.BANNED_PAGE.TITLE}
        </h4>

        {banReason == BanReason.PAYMENT_FAILURE ? (
          <h2 className="text-sm text-[#9D9D9D] text-center">
            {t.BANNED_PAGE.REASON_PAYMENT}
          </h2>
        ) : (
          <h2 className="text-sm text-[#9D9D9D] text-center">
            {t.BANNED_PAGE.REASON_VIOLATION}
          </h2>
        )}
      </CardContent>
    </Card>
  );
}
